import React from 'react';
import ReactLoading from 'react-loading';


const SectionLoader = ({ type, color }) => (
    <ReactLoading type={type} color={color} height={75} width={75} className="section-loader" />
);

export default SectionLoader;



// WEBPACK FOOTER //
// ./src/components/loader/SectionLoader.js